import React, { useEffect, useState } from "react";
import { getProducts } from "../api/products";
import ProductCard from "../components/ProductCard";

function OfferPage() {
    var [products, setProducts] = useState([]);
    var [loading, setLoading] = useState(true);
    var [error, setError] = useState(null);

    useEffect(function () {
        getProducts()
            .then(function (data) {
                var list = Array.isArray(data) ? data : (data.content || []);
                setProducts(list);
            })
            .catch(function (err) { setError(err.message); })
            .finally(function () { setLoading(false); });
    }, []);

    if (loading) { return <div className="container py-4">Načítavam ponuku…</div>; }
    if (error)   { return <div className="container py-4 text-danger">Chyba: {error}</div>; }

    return (
        <div className="container py-4">
            {/*<h1 className="h4 mb-3">Naša ponuka</h1>*/}

            <div className="row g-4">
                {products.map(p => (
                    <div key={p.id} className="col-12 col-md-6 col-lg-4 col-xl-3">
                        <ProductCard product={p} />
                    </div>
                ))}
            </div>
        </div>
    );
}

export default OfferPage;
